// material-ui
import { useTheme } from "@mui/material/styles";
import { Badge, IconButton } from "@mui/material";
import { useStateValue } from "store";
import { Textsms } from "@mui/icons-material";
import { useEffect } from "react";
import API from "services/Api";
import usePermissions from "hooks/usePermissions";
import { formatPhoneNumber } from "helpers/format";

const MessagingNotificationSection = () => {
  const theme = useTheme();
  const { userPerms } = usePermissions();
  const [{ userLocation, messages, jobs }, dispatch] =
    useStateValue();

  const smsPhone = userLocation?.smsSendPhone || null;
  const enabled = userLocation?.enableMessaging || false;
  const userEnabled = userPerms.messaging !== 1 && userPerms.texting !== 1

    const connectUnreadMessagesToJobAdmins = (messages) => {
      messages.forEach((m) => {
        if(m.jobAdminId === null){
        let job = jobs.allJobs.find(
          (j) => formatPhoneNumber(j.clientCellular) === formatPhoneNumber(m.from)
        );
        if (job) {
          m.jobAdminId = job.jobAdminId;
          m.displayJobAdmin = job.hat || job.jobAdminInt;
          m.displayName = job.clientName;
        } else {
          m.displayJobAdmin = "Unknown"
          m.displayName = "Unknown"
        }
      }
      });
      return messages;
    };

  const getLocationMessages = (phone) => {
    API.getData("Messages", `all/byphone/${phone}`).then((res) => {
      if(res){
      dispatch({ type: "MESSAGES_UPDATE", payload: res });
      let unreadMessages = connectUnreadMessagesToJobAdmins(res).filter(
        (m) => m.isIncoming && !m.readAt && m.displayJobAdmin !== "Unknown"
      );
      dispatch({ type: "UNREAD_MESSAGES_UPDATE", payload: unreadMessages });
      }
    });
  };

  useEffect(() => {
    const messagesDirtyEvent = (e) => {
      getLocationMessages(smsPhone);
      console.log("job dirty event from leaderboard view");
    };
    if (smsPhone && enabled && userEnabled) {
      getLocationMessages(smsPhone);
      window.addEventListener("incomingMessage", messagesDirtyEvent);
      window.addEventListener("readMessage", messagesDirtyEvent);
    } else {
      console.log("Messaging is disabled")
    }
    return () => {
      if (smsPhone && enabled && userEnabled) {
      window.removeEventListener("incomingMessage", messagesDirtyEvent);
      window.removeEventListener("readMessage", messagesDirtyEvent);
      }
    };
  }, [smsPhone, enabled]);

  return (
    <>
      {enabled && smsPhone && (
        <IconButton
          color="inherit"
          sx={{ color: theme.palette.secondary.main }}
          disabled={userPerms.messaging === 1 || userPerms.texting === 1}
          onClick={() => dispatch({ type: "OPEN_MESSAGING_DRAWER" })}
        >
          <Badge
            invisible={messages.unreadCount === 0 || userPerms.messaging === 1 || userPerms.texting === 1}
            color="error"
            badgeContent={messages.unreadCount}
          >
            <Textsms />
          </Badge>
        </IconButton>
      )}
    </>
  );
};

export default MessagingNotificationSection;
